/**
 * If you want to enable logs from datafeed set it to `true`
 */
var isLoggingEnabled = false;
var ClientCode = "Anonymous User"
export function logMessage(message:string,level = 0) {
    if (isLoggingEnabled) {
        const now = new Date();
        // tslint:disable-next-line:no-console
        if( level ==  0){
            console.info(`${ClientCode}>${now.toLocaleTimeString()}.${now.getMilliseconds()}> ${message}`);
        }else if(level = 2){
            console.warn(`${ClientCode}>${now.toLocaleTimeString()}.${now.getMilliseconds()}> ${message}`)
        }
        
    }
}

export function setLogging(flag:boolean){
    isLoggingEnabled = flag
}

export function setLoggingCC(client_code:string){
    ClientCode = client_code
}
export function getErrorMessage(error:any) {
    if (error === undefined) {
        return '';
    }
    else if (typeof error === 'string') {
        return error;
    }
    return error.message;
}


export function toFixedNumber(num:number, decimals = 2) {
    return Number(num.toFixed(decimals));
}


export function multiplequoteURLMaker(exchange: string, tokens: number[]): string {
    const baseUrl = "aux/analytics/quote?";
    const queryParams: string[] = [];
    
    // Loop through the tokens and create the query string for each token
    tokens.forEach(token => {
      queryParams.push(`q=${exchange}-${token}`);
    });
    
    // Join all the query parameters with "&" and add the mode parameter
    const fullUrl = baseUrl + queryParams.join("&") + "&mode=ltp";
    
    return fullUrl;
  }

  export function findLTPLessThan10Percent({
    memorizedLTP,
    ltps
  }: {
    memorizedLTP: number;
    ltps: {
      [key: string]: {
        last_trade_price: number;
      };
    };
  }): { memorizedLTP: number; ltpLessThan10Percent: string; ltpPrice: number } {
    
    // Calculate 10% of memorizedLTP
    const tenPercent = memorizedLTP * 0.10;
    
    let ltpLessThan10PercentKey = "";
    let ltpPrice = -1;
    
    // Loop through each entry in ltps to find those strictly less than 10% of memorizedLTP
    for (const key in ltps) {
      const lastTradePrice = ltps[key].last_trade_price;
      
      if (lastTradePrice < tenPercent) {
        // Find the maximum value of those that are less than 10%
        if (ltpPrice === -1 || lastTradePrice > ltpPrice) {
          ltpPrice = lastTradePrice;
          ltpLessThan10PercentKey = key;
        }
      }
    }
    
    // Return the result (LTP key and price)
    return {
      memorizedLTP,
      ltpLessThan10Percent: ltpLessThan10PercentKey,
      ltpPrice
    };
  }
  
  
  
 export function splitOptionSymbol(symbol:string) {
    let index = "";
    let year = "";
    let month = "";
    let strike = "";
    let optionType = "";
    
    let i = 0;
    
    // Extract index (letters until we hit a number)
    while (i < symbol.length && isNaN(parseInt(symbol[i]))) {
      index += symbol[i];
      i++;
    }
    
    // Extract year (numbers until we hit a letter)
    while (i < symbol.length && !isNaN(parseInt(symbol[i]))) {
      year += symbol[i];
      i++;
    }
    
    // Extract month (letters until we hit a number)
    while (i < symbol.length && isNaN(parseInt(symbol[i]))) {
      month += symbol[i];
      i++;
    }
    
    // Extract strike (numbers until we hit a letter)
    while (i < symbol.length && !isNaN(parseInt(symbol[i]))) {
      strike += symbol[i];
      i++;
    }
    
    // Extract option type (remaining letters)
    while (i < symbol.length && isNaN(parseInt(symbol[i]))) {
      optionType += symbol[i];
      i++;
    }
    
    return {
      index,
      year,
      month,
      strike,
      optionType
    };
  }


  export const longestCommonStringFromStart = (s1: string, s2: string) => {
    let result = '';
    let i = 0;
    while (i < s1.length && i < s2.length && s1[i] === s2[i]) {
      result += s1[i];
      i++;
    }
    return result;
  };


  export function getBrokerageExchange(segmentId: number | null): string {
    if (segmentId === 1) {
      return 'NSECM';
    } else if (segmentId === 2) {
      return 'NSEFO';
    } else if (segmentId === 3 || segmentId === 8) {
      return 'BSECM';
    } else if (segmentId === 4) {
      return 'BSEFO';
    } else if (segmentId === 5 || segmentId === 6 || segmentId === 16) {
      return 'MCXCOM';
    } else if (segmentId === 13 || segmentId === 14 || segmentId === 2048) {
      return 'NSECUR';
    } else {
      return 'NSE_EQ';
    }
  }
  